import { FunctionComponent } from 'react'
import { Text } from '../../primitives/Text/Text'
import { useActions } from 'src/hooks/useActions'
import classNames from 'classnames'
import './DateItem.scss'
import { CalendarDateItem } from '../CalendarModal.types'

export const DateItem: FunctionComponent<CalendarDateItem> = ({
  day,
  dayNumber,
  month,
  isSelected,
  borderColor,
  outlineColor,
  actions
}) => {
  const { onClick } = useActions(actions)

  return (
    <button
      type="button"
      className={classNames('calendar-date-item', {
        'calendar-date-item--selected': isSelected
      })}
      onClick={onClick}
      aria-pressed={isSelected}
      style={{
        borderColor: isSelected ? borderColor : undefined,
        outlineColor: outlineColor
      }}>
      <Text {...day} />
      <Text {...dayNumber} />
      <Text {...month} />
    </button>
  )
}
